import { HydrationPerson } from '../hydration.models';
import type { CooPerson } from '../ku4-draft.models';

export function hydratePersons(persons?: CooPerson[]): HydrationPerson[] | undefined {
  if (!persons?.length) {
    return undefined;
  }

  return persons.map(hydratePerson);
}

function hydratePerson(person: CooPerson): HydrationPerson {
  const result: HydrationPerson = {
    name: person.name ?? '',
    dateGroup: { dob: person.birthdate ?? '' },
  };

  if (person.dateOfDeath) {
    result.dateGroup.dod = person.dateOfDeath;
  }

  if (person.children?.length) {
    result.children = person.children.map(hydratePerson);
  }

  return result;
}
